import React from 'react';
import config from '../../config';
import { FormattedMessage } from '../../util/reactIntl';
import { useIntl } from 'react-intl'
// import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';

import css from './AboutPage.module.css';
import image from './about-us.webp';

const AboutPage = () => {
  const intl = useIntl();
  const { siteFacebookPage, siteInstagramPage, siteLinkedInPage } = config;
  // const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage( {id:"AboutUsPage.schemaTitle"}, {siteTitle: siteTitle})
  const schemaDescription = intl.formatMessage( {id:"AboutUsPage.schemaDescription"})

  return (
    <StaticPage
      title={schemaTitle}
      description={schemaDescription}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: schemaDescription,
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>
            <FormattedMessage id="AboutUsPage.heading" />
          </h1>
          <img
            className={css.coverImage}
            src={image}
            alt="Man standing up and watching Madeira sunset."
          />

          <div className={css.contentWrapper}>
            <div className={css.contentSide}>
              <p>
                <FormattedMessage id="AboutUsPage.quote" />
              </p>
            </div>

            <div className={css.contentMain}>
              <p>
                <FormattedMessage id="AboutUsPage.firstParagraph" />
              </p>

              <p className={css.secondParagraph}>
                <FormattedMessage id="AboutUsPage.secondParagraph" />
              </p>

              <h3 className={css.subtitle}>
                <FormattedMessage id="AboutUsPage.thirdParagraphQuestion" />
              </h3>
              <em>
                <FormattedMessage id="AboutUsPage.thirdParagraphAnswer" />
              </em>
              <h2 className={css.subtitle}>
                <FormattedMessage id="AboutUsPage.touristQuestion" />
              </h2>
              <p>
                <FormattedMessage id="AboutUsPage.touristAnswer" />
              </p>
              <h2 className={css.subtitle}>
                <FormattedMessage id="AboutUsPage.SAQuestion" />
              </h2>
              <p>
                <FormattedMessage id="AboutUsPage.SAAnswer" />
              </p>

              <h2 className={css.subtitle}>
                <FormattedMessage id="AboutUsPage.TOQuestion" />
              </h2>
              <p>
                <FormattedMessage id="AboutUsPage.TOAnswer" />
              </p>

              <p className={css.lastParagraph}>
                <hr />
                <FormattedMessage id="AboutUsPage.conclusion" />
              </p>
              <p>
                <FormattedMessage id="AboutUsPage.socialMedia" />{' '}
                <ExternalLink href={siteFacebookPage}>Facebook</ExternalLink>,&nbsp;
                <ExternalLink href={siteInstagramPage}>Instagram</ExternalLink> and{' '}
                <ExternalLink href={siteLinkedInPage}>LinkedIn</ExternalLink>.
              </p>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
